import { gql } from 'apollo-angular'

import { ARTICLE_WITH_AUTHORS_FIELDS } from '../../fragments/article-fragments'
import { AUTHOR_BASIC_FIELDS } from '../../fragments/author.fragments'

export const GET_ARTICLE_BY_ID = gql`
  ${ARTICLE_WITH_AUTHORS_FIELDS}
  ${AUTHOR_BASIC_FIELDS}
  query getArticleById($articleId: Int!) {
    Article(id: $articleId, select: true) {
      ...ArticleWithAuthorsFields
      sub_articles {
        ...ArticleWithAuthorsFields
      }
      edition {
        id
      }
      magazine {
        id
      }
    }
  }
`
